import React, { useEffect, useRef, useState, useMemo } from "react";
import { FiSend, FiX, FiMessageCircle, FiBell, FiSettings, FiPaperclip, FiMic } from "react-icons/fi";
import { FaRobot, FaUserCircle } from "react-icons/fa";
import "./ERPChatbot.css";

export default function ERPChatbot() {
  const [open, setOpen] = useState(false);
  const [messages, setMessages] = useState([
    { id: "b1", author: "bot", text: "Hi! I’m a Chatbot. Ask me about Orders, Inventory, or Mould status." },
  ]);
  const [input, setInput] = useState("");
  const [typing, setTyping] = useState(false);
  const [unread, setUnread] = useState(0);
  const listRef = useRef(null);

  // Auto-scroll
  useEffect(() => {
    if (listRef.current) {
      listRef.current.scrollTop = listRef.current.scrollHeight;
    }
  }, [messages, typing, open]);

  // Demo bot replies

  
  const fakeBotResponse = (userText) => {
    const t = userText.toLowerCase();
    if (t.includes("order")) return "You can track orders by Part No or Work Order.";
    if (t.includes("inventory")) return "Current stock at WH-01 is 2,145 units.";
    if (t.includes("mould") || t.includes("mold")) return "Mould MLD-102 is due for PM in 3 days.";
    if (t.includes("qc")) return "There are 5 pending inspections. Lot L-2893 requires dimensional check.";
    return "Got it! I’ll check and get back to you. (Demo reply)";
  };

  const send = async (text) => {
    const msgText = text || input.trim();
    if (!msgText) return;
    const userMsg = { id: crypto.randomUUID(), author: "user", text: msgText };
    setMessages((m) => [...m, userMsg]);
    setInput("");
    setTyping(true);

    setTimeout(() => {
      const reply = fakeBotResponse(msgText);
      const botMsg = { id: crypto.randomUUID(), author: "bot", text: reply };
      setMessages((m) => [...m, botMsg]);
      setTyping(false);
      if (!open) setUnread((u) => u + 1);
    }, 900);
  };

  const onKey = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  const quickPrompts = useMemo(
    () => [
      "Show today’s production plan",
      "Create a purchase request",
      "Where is Mould MLD-102?",
    //   "Pending QC inspections",
    //   "Generate pick list for Rack A3",
    ],
    []
  );

  return (
    <>
      {/* Floating Button */}
      {!open && (
        <button
          className="erp-fab"
          onClick={() => {
            setOpen(true);
            setUnread(0);
          }}
        >
          <FiMessageCircle className="erp-fab-icon" />
          {unread > 0 && <span className="erp-unread">{unread}</span>}
        </button>
      )}

      {/* Chat Panel */}
      <div className={`erp-chat-panel ${open ? "open" : ""}`}>
        <div className="erp-chat-header">
        <div className="erp-chat-title">
  <span className="erp-chat-badge">
    <img src="/favicon.jpg" alt="Chatbot" className="w-8 h-8" />

  </span>
  <div>
    <div className="title">Larch Erp Chatbot</div>
    <div className="subtitle">Online • LARCH ERP</div>
  </div>
</div>

          <div className="header-actions flex gap-3">
  <button className="icon-btn"><FiBell /></button>
  <button className="icon-btn"><FiSettings /></button>
  <button className="icon-btn" onClick={() => setOpen(false)}><FiX /></button>
</div>

        </div>

        {/* Suggestions */}
        <div className="erp-suggestions">
          {quickPrompts.map((p) => (
            <button key={p} className="chip" onClick={() => send(p)}>{p}</button>
          ))}
        </div>

        {/* Chat Body */}
{/* Chat Body */}
<div className="erp-chat-body" ref={listRef}>
  {messages.map((m) => (
    <div key={m.id} className={`msg-row ${m.author}`}>
      {m.author === "bot" && (
        <div className="avatar">
          <img src="/favicon.jpg" alt="Bot" className="w-6 h-6 rounded-full" />
        </div>
      )}
      <div className={`bubble ${m.author}`}>{m.text}</div>
      {m.author === "user" && (
        <div className="avatar">
          <FaUserCircle size={20} />
        </div>
      )}
    </div>
  ))}

  {typing && (
    <div className="msg-row bot">
      <div className="avatar">
        <img src="/favicon.jpg" alt="Bot" className="w-6 h-6 rounded-full" />
      </div>
      <div className="bubble bot typing">
        <span className="dot" /><span className="dot" /><span className="dot" />
      </div>
    </div>
  )}
</div>

        {/* Composer */}
        <div className="erp-chat-composer">
          <button className="icon-btn"><FiPaperclip /></button>
          <button className="icon-btn"><FiMic /></button>
          <textarea
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={onKey}
            placeholder="Ask about orders, inventory, maintenance…"
            rows={1}
          />
          <button className="send-btn" onClick={() => send()}><FiSend /></button>
        </div>
      </div>
    </>
  );
}
